import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentValidationFailedAction = {
	type: 'DOCUMENT_VALIDATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentValidationFailedAction => ({
	type: 'DOCUMENT_VALIDATION_FAILED',
	payload,
});
